module.exports = __webpack_public_path__ + "img/27.09c85f67.jpg";